module.exports = __webpack_public_path__ + "static/media/veda-patashala.2ea38a3c.jpeg";